import { getMetadata, StorageError, StorageReference, FullMetadata } from "firebase/storage";
import { useEffect } from "react";
import { LoadingHook, useComparatorRef, useLoadingValue } from "react-firebase-hooks/util";

export type MetadataHook = LoadingHook<FullMetadata, StorageError>;

export default function useMetadata(storageRef?: StorageReference | null): MetadataHook {
	const { error, loading, reset, setError, setValue, value } = useLoadingValue<
		FullMetadata,
		StorageError
	>();

	const ref = useComparatorRef(storageRef, isEqual, reset);

	useEffect(() => {
		if (!ref.current) {
			setValue(undefined);
			return;
		}
		getMetadata(ref.current).then(setValue).catch(setError);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [ref.current]);

	return [value, loading, error];
}

function isEqual(
	v1: StorageReference | null | undefined,
	v2: StorageReference | null | undefined,
): boolean {
	const bothNull = !v1 && !v2;
	const equal = !!v1 && !!v2 && v1.fullPath === v2.fullPath;
	return bothNull || equal;
}
